import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import MyContainer from "../../../MyContainer";
import ProductCard from "../../../ui/ProductCard";
import Reveal from "../../../ui/Reveal";
import SectionEyebrow from "../../../ui/SectionEyebrow";
import { useProductHighlightsSectionStyles } from "./ProductHighlightsSection.styles";
import { useI18n } from "../../../../i8n/useI18n";
import { useCommerceData } from "../../../../hooks/useCommerceData";
import { commerceRepository } from "../../../../api";

const ProductHighlightsSection = () => {
    const { classes } = useProductHighlightsSectionStyles();
    const { t } = useI18n();
    const { data } = useCommerceData(() => commerceRepository.getProducts({ sortKey: "CREATED", first: 4 }), []);

    return (
        <MyContainer>
            <Reveal>
                <Box className={classes.header}>
                    <Box>
                        <SectionEyebrow label={t("home.productHighlightsSection.overline")} />
                        <Typography variant="h2" sx={{ mt: 2 }}>{t("home.productHighlightsSection.title")}</Typography>
                        <Typography variant="body1" className={classes.description}>
                            {t("home.productHighlightsSection.description")}
                        </Typography>
                    </Box>
                    <Button variant="outlined" component={RouterLink} to={t("links.shop")}>
                        {t("home.productHighlightsSection.cta")}
                    </Button>
                </Box>
            </Reveal>

            <Box className={classes.grid}>
                {data?.items.map((product, index) => (
                    <Reveal key={product.id} delay={index * 0.05}>
                        <ProductCard product={product} badge={t("common.newBadge")} />
                    </Reveal>
                ))}
            </Box>
        </MyContainer>
    );
};

export default ProductHighlightsSection;
